import React, { useEffect, useState, useCallback } from 'react';
import {
    Alert,
    Avatar,
    Box,
    Button,
    ListItemAvatar,
    Checkbox,
    Grid,
    Card,
    CardContent,
    Paper,
    List,
    InputAdornment,
    Typography,
    TextField,
    MenuItem,
    ListItem,
    ListItemText,
    OutlinedInput,
    Drawer,
    IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { IconSearch } from '@tabler/icons';

// import TicketDrawer from '../../../authentication//TicketDrawer';
// import TicketDrawer from '../../../ticket/TicketDrawer';
// import TicketDrawerCreate from './TicketDrawerCreate';
import ChannelDrawerCreate from './ChannelDrawerCreate';
// import CommentItem from './CommentItem';
import { makeStyles } from '@mui/styles';
// import { token } from '../../../api';
import { token } from '../../../../../api';
import { useHistory } from 'react-router-dom';
import ChannelDrawer from './ChannelDrawer';
import api from '../../../../services/api';

// Se você já tem um api.js, importe-o em vez de criar headers manualmente.
const API_BASE = process.env.REACT_APP_BACKEND_SERVER || 'http://127.0.0.1:8000';
const getAuthHeader = () => ({ Authorization: `Token ${localStorage.getItem('authToken')}` });

const useStyles = makeStyles((theme) => ({
    searchControl: {
        width: '680px',
        marginLeft: '4px',
        marginBottom: '8px',
        background: '#fff',
        [theme.breakpoints.down('lg')]: { width: '100%' }
    },
    popperResults: {
        position: 'absolute',
        zIndex: 2000,
        width: '630px',
        backgroundColor: '#fff',
        boxShadow: theme.shadows[3],
        maxHeight: '250px',
        overflowY: 'auto',
        borderRadius: '8px',

        // novo:
        top: '250px', // a caixa fica logo abaixo do input
        left: '300px',
        right: 0
    },
    listItemHover: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover,
            cursor: 'pointer'
        }
    }
}));

const ChannelsPage = () => {
    const [solicitouMostrarInfo, setSolicitouMostrarInfo] = useState(false);
    const [channels, setChannels] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState(null);
    const [leftOpen, setLeftOpen] = useState(true);
    const [rightOpen, setRightOpen] = useState(true);
    const classes = useStyles();
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [showResults, setShowResults] = useState(false);
    const [listaApps, setListaApps] = useState([]);
    const [openDrawerChannel, setOpenDrawerChannel] = useState(false);
    const history = useHistory();
    const [appFoiSelecionado, setAppFoiSelecionado] = useState(false);
    const [drawerCreateOpen, setDrawerCreateOpen] = useState(false);
    const [status, setStatus] = useState({ type: '', message: '' });
    const [wizardData, setWizardData] = React.useState({
        app: {
            name: '',
            id: ''
        },
        integration: {
            name: '',
            id: '',
            type: ''
        },
        switchboard: {
            name: '',
            id: ''
        },
        switchboardIntegration: {
            name: '',
            id: ''
        }
    });

    const handleOpenChannel = (channel) => {
        setSelectedChannel(channel);
    };

    //? ------------ DEFININDO PRIMEIRO APP COMO O SELECIONADO ------------
    useEffect(() => {
        if (listaApps.length > 0 && !wizardData.app.id) {
            setWizardData((prev) => ({
                ...prev,
                app: {
                    ...prev.app,
                    id: listaApps[0].id
                }
            }));
            setAppFoiSelecionado(true);
        }
    });

    const handleAppChange = (e) => {
        setWizardData((prev) => ({
            ...prev,
            app: { ...prev.app, id: e.target.value }
        }));
        setAppFoiSelecionado(true);
    };

    useEffect(() => {
        loadApps();
    }, []);

    const loadApps = async () => {
        console.log('entrou em loadApps');
        try {
            const res = await api.get(`v1/apps/`);
            if (res.data) {
                setListaApps(res.data.apps);
                console.log(`loadApps - Apps carregados: ${JSON.stringify(res.data.apps)}`);
                console.log('loadApps- fim');
            } else {
                setStatus({ type: 'error', message: 'Erro ao carregar Apps!' });
            }
            // const res = await axios.get(`${API_BASE}/api/v1/apps/`, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
        } catch (err) {
            console.error('Erro ao carregar Apps', err);
            setStatus({ type: 'error', message: 'Erro ao carregar Apps!' });
        }
    };

    // ? --------------------------- LISTANDO CANAIS ---------------------------

    useEffect(() => {
        loadChannels();
    }, [appFoiSelecionado, wizardData.app.id]);

    const loadChannels = async () => {
        try {
            // console.log(`loadChannels - URL: ${API_BASE}/api/v1/apps/${wizardData.app.id}/integrations/`);
            const res = await api.get(`v1/apps/${wizardData.app.id}/integrations/`);
            if (res.data) {
                console.log(`Canais carregados: ${JSON.stringify(res.data.integrations)}`);
                setChannels(res.data.integrations);
            } else {
                console.log('loadChannels - else');
                // setStatus({ type: 'alert', message: 'Erro ao carregar canais' });
            }
            // const res = await axios.get(`${API_BASE}/api/v1/apps/${wizardData.app.id}/integrations/`, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
        } catch (err) {
            console.error('Erro ao carregar canais', err);
            // setStatus({ type: 'error', message: `Erroo :${err}` });
        }
    };

    const openChannel = async (channel) => {
        // busca o ticket completo (com events/comments)
        try {
            const res = await api.get(`v1/apps/${wizardData.app.id}/channels/${channel.id}/`);
            // const res = await axios.get(`${API_BASE}/api/channels/${channel.id}/`, {
            //     headers: {
            //         Authorization: token,
            //         'Content-Type': 'application/json'
            //     }
            // });
            if (res.data) {
                setSelectedChannel(res.data);
            } else {
                setStatus({ type: 'error', message: 'Erro ao abrir canal' });
            }
        } catch (err) {
            console.error('Erro ao abrir canal', err);
            setStatus({ type: 'error', message: 'Erro ao abrir canal' });
        }
    };

    const openDrawerCreateChannel = () => setDrawerCreateOpen(true);

    const closeDrawerCreateChannel = () => setDrawerCreateOpen(false);

    const closeDrawer = () => setSelectedChannel(null);

    useEffect(() => {
        loadChannels();
    }, [selectedChannel]);

    // Função para buscar conforme digita (com debounce)
    const handleSearch = useCallback(
        debounce(async (value) => {
            if (!value) {
                setSearchResults([]);
                setShowResults(false);
                return;
            }
            try {
                const res = await api.get(`v1/apps/${wizardData.app.id}/channels/?search=${encodeURIComponent(value)}`);
                if (res.data) {
                    setSearchResults(res.data);
                    setShowResults(true);
                } else {
                    setStatus({ type: 'error', message: 'Erro na busca' });
                }
                // const response = await axios.get(`http://127.0.0.1:8000/api/channels/?search=${encodeURIComponent(value)}`, {
                //     headers: { Authorization: token }
                // });
            } catch (error) {
                console.error('Erro na busca:', error);
                setStatus({ type: 'error', message: 'Erro na busca' });
            }
        }, 400),
        []
    );

    const handleChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
        handleSearch(value);
    };

    const handleCreateChannel = () => {
        history.push(`/dashboard/config/new/channel`);
    };

    const handleOpenInfo = () => {
        setSolicitouMostrarInfo(true);
    };

    return (
        <Box gap={2} sx={{ height: '100%', width: '100%', p: 0.1 }}>
            <Card>
                {status.message && (
                    <Alert severity={status.type} sx={{ mb: 2 }}>
                        {status.message}
                    </Alert>
                )}
                <Box sx={{ flex: 9, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                    <Typography variant="h2" sx={{ mb: 2, marginTop: 3, marginLeft: 2 }}>
                        Canais de Mensagens
                    </Typography>
                    <Typography variant="h6" sx={{ marginLeft: 2, mb: 2, width: '300px' }}>
                        Integre seus canais de mensagens para otimizar o suporte para cliente e agentes.
                    </Typography>

                    {/* Select App */}
                    <Grid
                        variant="contained"
                        color="primary"
                        sx={{
                            mb: 2,
                            ml: 2,
                            width: '160px',
                            marginLeft: '10px',
                            marginTop: 4,
                            display: 'flex',
                            flex: 1
                        }}
                        item
                        xs={12}
                        sm={6}
                        marginTop={3}
                        marginLeft={3}
                    >
                        <TextField select label="Selecione o App" value={wizardData.app.id} onChange={handleAppChange} fullWidth>
                            {listaApps.map((app) => (
                                <MenuItem key={app.id} value={app.id}>
                                    {app.displayName}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                </Box>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleCreateChannel}
                    sx={{
                        backgroundColor: '#a3ccc7',
                        mb: 2,
                        ml: 2,
                        width: '160px',
                        marginLeft: '800px',
                        marginTop: -20,
                        display: 'flex',
                        flex: 1
                    }}
                >
                    Adicionar canal
                </Button>
                <CardContent
                    sx={{
                        marginTop: 15
                    }}
                >
                    {/* Cabeçalho */}
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '60px 230px 180px 200px 250px 300px',
                            fontWeight: 'bold',
                            pb: 1,
                            borderBottom: '2px solid #eee',
                            marginTop: 3
                        }}
                    >
                        <Typography></Typography>
                        <Typography>Nome</Typography>
                        <Typography>Canal</Typography>
                        <Typography>Status</Typography>
                        <Typography>Respondido por</Typography>
                        {/* <Typography>Tipo de resposta</Typography> */}
                        <Typography></Typography>
                    </Box>

                    {/* Linhas da tabela */}
                    {channels.map((channel) => (
                        <Box
                            key={channel.id}
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: '60px 230px 180px 200px 250px 300px',
                                borderBottom: '1px solid #f0f0f0',
                                py: 1,
                                alignItems: 'center',
                                cursor: 'pointer'
                            }}
                            onClick={(e) => {
                                // console.log(`Clicou no canal ${channel.id}`);
                                setSelectedChannel(channel);
                                // console.log(`SelectedChannel: ${JSON.stringify(selectedChannel)}`);
                                // if (e.target.tagName !== 'INPUT' && !e.target.dataset.org) {
                                //     handleOpenUser(user);
                                // }
                            }}
                        >
                            {/* Avatar do canal */}
                            <ListItemAvatar>
                                {channel.type === 'whatsapp' && <Avatar src={'/whatsapp_icon.png'} />}
                                {channel.type === 'messenger' && <Avatar src={'/messenger_icon.png'} />}
                                {channel.type === 'chat' && <Avatar src={'/chat_icon3.png'} />}
                                {channel.type === 'instagram' && <Avatar src={'/instagram_icon.png'} />}
                                {channel.type === 'email' && <Avatar src={'/email_icon.png'} />}
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    sx={{
                                        mt: 0.5,
                                        textAlign: 'center',
                                        fontSize: '0.9rem',
                                        width: '70px',
                                        lineHeight: '1.5',
                                        right: '50%'
                                    }}
                                ></Typography>
                            </ListItemAvatar>

                            {/* Nome */}
                            <Typography>{channel.displayName}</Typography>

                            {/* Tipo */}
                            <Typography>{channel.type || '—'}</Typography>

                            {/* Ativo */}
                            {channel.status === 'active' && <Typography>Ativo</Typography>}
                            {channel.status === 'inative' && <Typography>Inativo</Typography>}

                            {/* <Typography>{channel.defaultResponderEnabled_id || '—'}</Typography> */}
                            <Typography marginLeft={2} variant="body2">
                                {channel.defaultResponderEnabled_id ? channel.defaultResponderEnabled_id.name : 'Não definido'}
                            </Typography>
                            {/* Tipo da integração */}
                            {/* <Typography>{channel.type_reply || 'Integração de resposta'}</Typography> */}
                        </Box>
                    ))}
                </CardContent>
            </Card>

            <Drawer anchor="right" open={!!selectedChannel} onClose={closeDrawer} PaperProps={{ sx: { width: '60vw', p: 0 } }}>
                {selectedChannel && (
                    <ChannelDrawer channel={selectedChannel} app_id={wizardData.app.id} onClose={closeDrawer} onSaved={loadChannels} />
                )}
            </Drawer>

            <Drawer anchor="right" open={!!drawerCreateOpen} onClose={closeDrawer} PaperProps={{ sx: { width: '60vw', p: 0 } }}>
                {drawerCreateOpen && <ChannelDrawerCreate onClose={closeDrawerCreateChannel} onSaved={loadChannels} />}
            </Drawer>
        </Box>
    );
};

// Debounce utilitário para evitar spam na API
function debounce(func, delay) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => func(...args), delay);
    };
}

export default ChannelsPage;
